import React from "react";

const DashboardSkeletonLoading = () => {
  return (
    <>
      {/* row - 1 */}
      <div className="animate-pulse grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  justify-between gap-10 w-full mb-10">
        {Array(4)
          .fill(0)
          .map((_, index) => (
            <div
              key={index}
              className="mb-3 rounded-2xl bg-gray-300/40 border-gray-300 shadow"
            >
              <div className="p-3">
                <div className="flex flex-row justify-between items-center">
                  <div>
                    <span className="text-2xl font-bold text-[#344767]">0</span>
                    <div className="flex items-center justify-start w-24 h-2.5 bg-gray-400/60 shadow border-gray-400 rounded-3xl" />
                  </div>
                  <div className="rounded-3xl h-20 w-20 bg-gray-400 shadow border-gray-400/60 p-1" />
                </div>
              </div>
            </div>
          ))}
        <span className="sr-only">Loading...</span>
      </div>
    </>
  );
};

export default DashboardSkeletonLoading;
